class StockLocationController extends AbstractController
	@register()
	@inject '$state',
		'stockLocation'
		'ConfigurationService'

	initialize: ->
		allowStockEvents = @ConfigurationService.isEnabled('Backoffice.StockManagement.StockLocations.EnableEvents')
		params = {}
		isNewEntity = true

		if not _.isEmpty @stockLocation
			isNewEntity = false
			params =
				id: @stockLocation.id

		@mainCrud.tabs = [
			{
				title: 'wbo.stock.details'
				url:
					state: 'stocklocations.edit.details'
					params: params
			}
			{
				title: 'wbo.stock.stock'
				disabled: !allowStockEvents || isNewEntity
				url:
					state: 'stocklocations.edit.liststock'
					params: params
			}
			{
				title: 'wbo.stock.events'
				disabled: !allowStockEvents || isNewEntity
				url:
					state: 'stocklocations.edit.listevents'
					params: params
			}
			{
				title: 'inventory.counts'
				disabled: isNewEntity
				url:
					state: 'stocklocations.edit.inventory_count'
					params: params
			}
			{
				title: 'general.products.to.count'
				disabled: !allowStockEvents || isNewEntity
				url:
					state: 'stocklocations.edit.products_to_count'
					params: params
			}
		]
